import styled from 'styled-components';
import { Button } from '@mui/material';
import { colors } from 'spw-theme';

export const OptionsButton = styled(Button)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding-left: 27.5px;
    padding-right: 27.5px;
    border-right: 1px solid ${colors.greyInputAddornment};
    height: 38px;
    border-radius: 0px;

    .MuiButton-label {
      margin-left: 0;

      .MuiButton-startIcon {
        margin-left: 0;
      }
    }

    &.left-border {
      border-left: 1px solid ${colors.greyInputAddornment};
    }

    span {
      font-size: 14px;
      margin-left: 0px;
    }

    &.Mui-disabled {
      opacity: 0.75;
    }

    span,
    svg {
      color: ${colors.white} !important;
    }
  }
`;
